import {
  FOOD_TYPE,
  NON_FOOD_TYPE,
} from 'pages/new-evaluation-form/constants/evaluationFormType';

export const isFoodForm = (type) => type?.toLowerCase() === FOOD_TYPE;
export const isNonFoodForm = (type) => type?.toLowerCase() === NON_FOOD_TYPE;

export const isAllergensNonFoodForm = (type, nameTable) =>
  type?.toLowerCase() === NON_FOOD_TYPE &&
  nameTable?.toLowerCase() === 'allergendetails';
